import { render, staticRenderFns } from "./ApiService.vue?vue&type=template&id=5620cc3d&scoped=true&"
import script from "./ApiService.vue?vue&type=script&lang=js&"
export * from "./ApiService.vue?vue&type=script&lang=js&"
import style0 from "./ApiService.vue?vue&type=style&index=0&id=5620cc3d&prod&lang=css&"
import style1 from "./ApiService.vue?vue&type=style&index=1&id=5620cc3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5620cc3d",
  null
  
)

export default component.exports